import { Users } from "lucide-react";

const COLORS = ["bg-sky-100 text-sky-800", "bg-emerald-100 text-emerald-800", "bg-amber-100 text-amber-800", "bg-rose-100 text-rose-800", "bg-violet-100 text-violet-800"];

export default function GratitudeWall({ mural, metaId }) {
  if (!mural || mural.total === 0) return null;
  const nomes = mural.nomes.slice(0, 5);
  const extra = mural.total - nomes.length;
  if (nomes.length === 0) {
    return (
      <div data-testid={`goal-mural-${metaId}`} className="mt-4 flex items-center gap-2 rounded-2xl bg-gradient-to-r from-sky-50 to-white border border-sky-100 px-3.5 py-2.5 text-sm text-slate-600">
        <Users className="w-4 h-4 text-sky-700 shrink-0" />
        <span><span className="font-semibold text-slate-800">{mural.total} {mural.total === 1 ? "pessoa já ajudou" : "pessoas já ajudaram"}</span> esta meta. Junte-se a elas!</span>
      </div>
    );
  }
  const frase =
    nomes.length === 1
      ? `${nomes[0]} já ajudou`
      : `${nomes.slice(0, -1).join(", ")} e ${nomes[nomes.length - 1]}${extra > 0 ? ` e mais ${extra}` : ""} já ajudaram`;

  return (
    <div data-testid={`goal-mural-${metaId}`} className="mt-4 flex items-center gap-3 rounded-2xl bg-gradient-to-r from-sky-50 to-white border border-sky-100 px-3.5 py-2.5">
      <div className="flex -space-x-2 shrink-0">
        {nomes.slice(0, 4).map((n, i) => (
          <span key={n} className={`w-8 h-8 rounded-full ring-2 ring-white flex items-center justify-center text-xs font-extrabold ${COLORS[i % COLORS.length]}`} title={n}>
            {n[0]}
          </span>
        ))}
        {extra > 0 && (
          <span className="w-8 h-8 rounded-full ring-2 ring-white bg-[#0f2a6b] text-white flex items-center justify-center text-[10px] font-extrabold">+{extra}</span>
        )}
      </div>
      <p className="text-sm text-slate-600 leading-snug min-w-0">
        <Users className="w-3.5 h-3.5 inline mr-1 -mt-0.5 text-sky-700" />
        <span className="font-semibold text-slate-800">{frase}</span> esta meta. Junte-se a eles!
      </p>
    </div>
  );
}
